import React, { Component } from "react"
import { withTranslation } from "react-i18next"
import Article from "./Article"
import { Col, Row } from '@amzn/stencil-react-components/layout'
import { H2 } from '@amzn/stencil-react-components/text'

class HelpfulInformation extends Component {

  render() {
    const { t, articles } = this.props;

    if(articles.length == 0) {
      return null
    }

    const articlesWithVideo = [];
    const articlesWithoutVideo = [];

    articles.forEach((article) => {
      if (article.video_url) {
        articlesWithVideo.push(article);
      } else {
        articlesWithoutVideo.push(article);
      }
    })

    return (
      <Col dataTestId="HelpfulInformation" gridGap="S500">
        <H2>{t("HelpfulInformation.Title")}</H2>
        <Col alignItems="center">
          <Row gridGap="S500" flexWrap="wrap"> 
            {articlesWithVideo.length > 0 && articlesWithVideo.map(function(el, index) {
                return (
                    <Article key={`ArticleWithVideo_${index}`}
                      title={el.title}
                      description={el.description}
                      body={el.body}
                      video_url={el.video_url}
                    />
                );
              })}
          </Row>
        </Col>
        <Col>
            {articlesWithoutVideo.length > 0 && articlesWithoutVideo.map(function(el, index) {
              return (
                  <Article key={`ArticleWithoutVideo_${index}`}
                    title={el.title}
                    description={el.description}
                    body={el.body}
                  />
              );
            })}
        </Col>
      </Col>
    );
  }
}

export default withTranslation('translationsV2')(HelpfulInformation);
